import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CookieBanner.module.scss';

const CookieIcon = () => (
    <svg width="30" height="30" viewBox="0 0 64 64" fill="none">
        {/* Cookie with big sharp bite top-right */}
        <path
            d="M32 6
               A26 26 0 1 0 58 32
               L50 28 L56 20 L46 18 L52 10 L42 14 L40 6
               Z"
            stroke="#ff79c6" strokeWidth="2.2" fill="none"
            strokeLinejoin="miter" strokeLinecap="square"
        />
        {/* Dots / chips */}
        <circle cx="24" cy="24" r="2.8" fill="#ff79c6"/>
        <circle cx="35" cy="30" r="2.4" fill="#ff79c6"/>
        <circle cx="22" cy="38" r="2.2" fill="#ff79c6"/>
        <circle cx="36" cy="44" r="2.5" fill="#ff79c6"/>
        <circle cx="18" cy="30" r="1.8" fill="#ff79c6"/>
    </svg>
);

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const accepted = localStorage.getItem('ncore_cookie_accepted');
        if (!accepted) {
            // Small delay so it doesn't flash on first render
            const t = setTimeout(() => setVisible(true), 800);
            return () => clearTimeout(t);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('ncore_cookie_accepted', '1');
        setVisible(false);
    };

    const handleDetails = () => {
        navigate('/cookie-policy');
    };

    if (!visible) return null;

    return (
        <div className={styles.banner} role="dialog" aria-label="Уведомление о cookies">
            <div className={styles.top}>
                <div className={styles.iconWrap}>
                    <CookieIcon />
                </div>
                <p className={styles.title}>Мы используем куки</p>
            </div>
            <p className={styles.subtitle}>Потому что так работает интернет</p>
            <button className={styles.btnDetails} onClick={handleDetails}>
                Подробнее
            </button>
            <button className={styles.btnAccept} onClick={handleAccept}>
                Ладно
            </button>
        </div>
    );
};

export default CookieBanner;
